import { Button, Container, Paper, Stack, Typography, Select, MenuItem, Box } from '@mui/material';
import { FormProvider, SelectTag } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { dropdownFetch, toast } from '../../../../../utils';
import { BASE_URL } from '../../../../../utils';
import { useForm } from 'react-hook-form';
export const SponsorAlocator = () => {
  const [currentAction, setCurrentAction] = useState('');
  const [selectedRecord, setSelectedRecord] = useState({});
  const [roleDropdown, setRoleDropdown] = useState([]);
  const [sponcerList, setSponcerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sponcerExistingNew, setSponcerExistingNew] = useState([]);
  const [selectedSponcerExisting, setSelectedSponcerExisting] = useState(null);
  const [selectedSponcerNew, setSelectedSponcerNew] = useState(null);
  const methods = useForm();

  const getSponcerList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/sponsor/list`);
      setSponcerList(response.data.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getSponcerList();
  }, []);

   


   const formSubmit = async (formValues) => {
       setLoading(true);
       try {
        const response =  await axios.post(`${BASE_URL}/price-list-master/duplicate`, formValues);
        if(response.status === 201)
          toast(`Successfully Duplicated Existing Sponsor For The New Sponsor.`, { variant: 'success' });
        else{
          toast(`Feild Duplicated Existing Sponsor For The New Sponsor.`, { variant: 'error' });
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        toast(`Something Went Wrong`, { variant: 'warning' });
      }
       console.log(formValues);
       setLoading(false);
    };

  const inputStyle = {
    width: '60%',
    paddingTop: '3px',
    paddingBottom: '3px'
  };

  const { handleSubmit, watch, reset, setValue } = methods;
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Sponsor Alocator
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button type="submit" variant="contained" disabled={selectedSponcerExisting && selectedSponcerNew}>
                  Alocate
                </Button>
              </Stack>
            </Stack>

            <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
              <SelectTag
                formControlSX={{ flex: 0.8 }}
                name="existingSponsorId"
                menus={sponcerList.map((item) => ({ ...item, name: `${item?.name}` }))}
                placeholder="Select Sponsor Existing"
              />
            </Stack>
            <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
              <SelectTag
                formControlSX={{ flex: 0.8 }}
                name="newSponsorId"
                menus={sponcerList.map((item) => ({ ...item, name: `${item?.name}` }))}
                placeholder="Select Sponsor Existing"
              />
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
